import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { NotaOperacaoGarantida } from "src/app/model/nota.model";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
    providedIn: 'root'
})
export class NotasService extends FgiBackEndService<NotaOperacaoGarantida>{
    private operacao:OperacaoGarantida;
    private nota:NotaOperacaoGarantida;

    setOperacao(operacao:any){
        this.operacao = operacao;
    }

    getOperacao():any{
        return this.operacao;
    }

    getNewEntity(): NotaOperacaoGarantida {
        const model = new NotaOperacaoGarantida();
        //model.dataEnvio = new Date();
        return model;
    }    

    protected getResourceURL(): string {
        return 'front/notas';
    }

    getNotaTelaOperacao():NotaOperacaoGarantida{
        return this.nota;
    }

    setNotaTelaOperacao(nota:NotaOperacaoGarantida){
        this.nota = nota;
    }

    getNotas(params?: any):any{
        let options: any = blockUi();
        options.params = params;        
        return this.http.get(`${this.BASE_URL}`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<NotaOperacaoGarantida>>;
    }

    getAnexo(id:number) {
        return this.http.get(`${this.BASE_URL}/${id}/anexo`, { responseType: 'blob' }).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }
   
    save(entity: NotaOperacaoGarantida, anexo?: File, options?: any): Observable<NotaOperacaoGarantida> {
        let formData =  new FormData();
        formData.append("nota", JSON.stringify(entity));
        if (anexo) {
            formData.append("anexoNota", anexo);
        }
        
        return this.http.post(`${this.BASE_URL}/${ (entity.id) ? 'atualizar/'+entity.id : 'incluir'}`, formData, options).pipe(
            map(response => this.convertToType(response)),
            catchError((e) => this.handleError(e))) as Observable<NotaOperacaoGarantida>;
    }       

}